<template>
<div>
  <v-container fluid class="pa-2">

    <div class="d-flex align-center justify-space-between mb-4">
      <h2 class="section-title">Service Channel Management</h2>

      <div class="d-flex align-center" style="gap: 12px;">
        <v-btn color="primary" @click="openCreate">
          <v-icon left>mdi-plus</v-icon>
          New Channel
        </v-btn>

        <v-text-field
          v-model="search"
          dense
          outlined
          hide-details
          prepend-inner-icon="mdi-magnify"
          placeholder="Search"
          style="width: 320px;"
        />
      </div>
    </div>

    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="filteredItems"
        :items-per-page="10"
        class="elevation-1"
      >
        <template v-slot:item.actions="{ item }">
            <div class="action-inline">
              <v-btn icon small text elevation="0" color="primary" @click="openEdit(item)">
                <v-icon small>mdi-pencil-outline</v-icon>
              </v-btn>

              <v-btn icon small text elevation="0" color="red" @click="confirmDelete(item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>

        <template v-slot:no-data>
          <div class="pa-6 text-center grey--text">
            No service channel found
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>

  <!-- Dialog -->
  <v-dialog v-model="dialog.open" max-width="500">
    <v-card>
      <v-card-title>
        {{ dialog.mode === 'create' ? 'Create Channel' : 'Edit Channel' }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="dialog.valid">
          <v-text-field
            v-model="form.code"
            label="Code"
            outlined dense
            :disabled="dialog.mode === 'edit'"
            :rules="[rules.required]"
          />

          <v-textarea
            v-model="form.description"
            label="Description"
            outlined dense
            rows="4"
            counter="255"
            maxlength="255"
            :rules="[rules.maxLength]"
            placeholder="Enter description (max 255 characters)"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog.open = false">Cancel</v-btn>
        <v-btn color="primary" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
export default {
  name: 'ServiceChannelManagement',
  data () {
    return {
      search: '',
      items: [],
      dialog: {
        open: false,
        mode: 'create',
        valid: false
      },
      form: {
        code: '',
        description: ''
      },
      rules: {
        required: v => !!v || 'Required'
      }
    }
  },

  created () {
    this.fetchItems()
  },

  computed: {
    headers () {
      return [
        { text: 'Actions', value: 'actions', sortable: false, width: 100 },
        { text: 'Code', value: 'code' },
        { text: 'Description', value: 'description' }
      ]
    },
    filteredItems () {
      const q = (this.search || '').toLowerCase().trim()
      if (!q) return this.items

      return this.items.filter(i =>
        i.code.toLowerCase().includes(q) ||
        (i.description || '').toLowerCase().includes(q)
      )
    }
  },

  methods: {
    async fetchItems () {
      try {
        const endpoint = `${process.env.VUE_APP_API}/api/v1/service_channel`
        const res = await this.axios.get(endpoint)
        this.items = res.data.data || []
      } catch (e) {
        console.log(e)
      }
    },
    openCreate () {
      this.dialog.mode = 'create'
      this.form = { code: '', description: '' }
      this.dialog.open = true
    },
    openEdit (item) {
      this.dialog.mode = 'edit'
      this.form = { ...item }
      this.dialog.open = true
    },
    async save () {
      const ok = this.$refs.form.validate()
      if (!ok) return
      try {
        if (this.dialog.mode === 'create') {
          await this.axios.post(
            `${process.env.VUE_APP_API}/api/v1/register_service_channel`,
            this.form
          )
        } else {
          await this.axios.put(
            `${process.env.VUE_APP_API}/api/v1/update_service_channel/${this.form.code}`,
            { description: this.form.description }
          )
        }
        this.dialog.open = false
        await this.fetchItems()
      } catch (e) {
        alert(e.response?.data?.message || 'Save failed')
      }
    },
    async confirmDelete (item) {
      const code = item.code
      if (!code) {
        await this.$swal({ type: 'error', title: 'Error', text: 'Code is missing' })
        return
      }

      // 1) confirm
      const result = await this.$swal({
        text: `Do you want to delete service?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel'
      })
      const confirmed = result === true || (result && result.value)
      if (!confirmed) return

      // 2) loading
      this.$swal({
        title: 'Processing...',
        text: 'Please wait',
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: () => this.$swal.showLoading()
      })

      try {
        const endpoint = `${process.env.VUE_APP_API}/api/v1/delete_service_channel/${encodeURIComponent(code)}`

        const res = await this.axios.delete(endpoint)
        console.log('kkdev res ' + !res?.data?.success)

        if (!res?.data?.isSuccess) {
          throw new Error(res?.data?.message || 'Delete failed')
        }

        // 3) ลบแถวออกจาก UI ทันที (ไม่ต้อง fetch ใหม่)
        const idx = this.items.findIndex(i => i.code === code)
        if (idx !== -1) this.items.splice(idx, 1)

        await this.$swal({
          type: 'success',
          title: 'Delete Success',
          text: 'Channel deleted successfully'
        })
      } catch (e) {
        await this.$swal({
          type: 'error',
          title: 'Delete failed',
          text: e?.message || String(e)
        })
      }
    }
  }
}
</script>
<style>
.dialog-card {
  position: relative;
  border-radius: 12px;
}
.dialog-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 36px;
  height: 36px;
  min-width: 36px !important;
  border-radius: 50%;
}
.dialog-actions {
  padding: 16px 24px;
}
</style>